import { render, staticRenderFns } from "./AddShipment.vue?vue&type=template&id=4fb49848&scoped=true&"
import script from "./AddShipment.vue?vue&type=script&lang=js&"
export * from "./AddShipment.vue?vue&type=script&lang=js&"
import style0 from "./AddShipment.vue?vue&type=style&index=0&id=4fb49848&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb49848",
  null
  
)

export default component.exports